
import Vue from "vue";
//import {createSimpleTransition} from "vuetify/src/util/helpers";
// Components
import RomaActivityModalForm from "./RomaActivityModalForm.vue";
import RomaActivity from "./RomaActivity.vue";
import RomaNotification from "../../commons/RomaNotification.vue";
import RomaConfirmDialog from "../../commons/RomaConfirmDialog.vue";
import UnitPlanActivity from "../../../store/planner/activity/UnitPlanActivity";
import UnitPlanActivityDua from "../../../store/planner/activity/UnitPlanActivityDua";
import UnitPlanActivityFile from "../../../store/planner/activity/UnitPlanActivityFile";
import UnitPlanActivityIe from "../../../store/planner/activity/UnitPlanActivityIe";
import { DownloadIcon } from 'vue-feather-icons';
// @ts-ignore
import draggable from "vuedraggable";
// Models
// Rich Text Editor
import {
  Blockquote,
  Bold,
  BulletList,
  HardBreak,
  Heading,
  History,
  HorizontalRule,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Paragraph,
  Strike,
  TiptapVuetify,
  Underline,
} from "tiptap-vuetify";
import UnitPlan from "../../../store/units/UnitPlan";
import { groupBy, orderBy } from "lodash";
import Oa from "@/store/planner/objetive/Oa";
import { uniqBy } from "lodash";

/* const romaActivityListTransition = createSimpleTransition(
  "activity-list-transition"
); */
//Vue.component("my-transition", romaActivityListTransition);

export default Vue.extend({
  name: "RomaActivityList",
  props: {
    unit: {
      type: Object,
      required: true,
    },
    loadingActivities: {
      type: Boolean,
      required: false
    },
    selectedWeekFromCoverage: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      userId: this.$store.state.user.userId,
      userPrivileges: this.$store.state.user.privileges,
      isUTP: this.$store.state.user.isUTP,
      dialog: false,
      dialogDeleteActivity: false,
      selectedActivity: null,
      originalNotification: null,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  computed: {
    activities: {
      get() {
        let activitiesWithOrder = orderBy(UnitPlanActivity.query()
          .where("unitplan_id", this.unit.id)
          .with("duas")
          .with("files")
          .with("ies", (queryIE) => {
            queryIE.where((ie: any) => !ie.disabled && !ie.rescheduled);
          })
          .get(), ['semanaClase.fechaInicio', 'id']);

        activitiesWithOrder = activitiesWithOrder.map((activity: any) => {
          activity.duas = uniqBy(activity.duas, "id");
          return activity;
        });

        if (activitiesWithOrder.length == 0) {
          this.originalNotification = {
            type: 'NOINFOFOUND',
            title: 'Sin planificaciones',
            messages: ['No hay planificaciones agregadas'],
            customPosition: true,
            showXIcon: false
          }
        }
        return [
          ...activitiesWithOrder,
        ];
      },
      async set(data: any[]) {
        // Guarda el arreglo original
        const originalOrder = this.activities.slice();

        // Modifica el orden de acuerdo al index y actualiza
        data.forEach((value, index) => (value.order = index + 1));
        UnitPlanActivity.update({ data });

        // Persiste en base de datos
        const r = await this.$store.dispatch(
          "updateActivityOrders",
          data.map((a) => ({ id: a.id, order: a.order }))
        );
        if (!(r.data && r.data.status && r.data.status.code === 1)) {
          // Revierte al orden original en caso de que no haya persistido
          UnitPlanActivity.update({ data: originalOrder });
          this.$store.state.snackbar = {
            show: true,
            color: "red",
            text: "No se pudo guardar el orden, por favor vuelva a intentarlo",
          };
        } else {
          //console.log("Orden guardado", data);
        }
      },
    },
  },
  watch: {
    selectedWeekFromCoverage: {
      handler(newVal) {
        if (newVal) {
          this.scrollToActivity(newVal);
        }
      },
      immediate: true
    },
    loadingActivities(val) {
      if (!val && this.selectedWeekFromCoverage) {
        this.scrollToActivity(this.selectedWeekFromCoverage);
      }
    }
  },
  methods: {
    scrollToActivity(week: any) {
      const activity = this.activities.find((a: any) => a.semanaClase && a.semanaClase.id === week.id);
      if (activity) {
        this.$nextTick(() => {
          const element = document.getElementById('activity-card-' + activity.id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.classList.add('highlight-activity');
            setTimeout(() => {
              element.classList.remove('highlight-activity');
            }, 2000);
          }
        });
      }
    },
    refreshActivities(refreshNeeded: boolean) {
      this.selectedActivity = null;
      if (refreshNeeded) {
        this.$emit('refresh-activities');
      }

    },
    groupByOa(ies: any) {
      const oas = groupBy(ies, (n) => {
        return n.oa_id;
      });
      return orderBy(Oa.findIn(Object.keys(oas)), ["cod"]).map((oa: any) => oa.cod).join(",");
    },
    downloadFile(file: UnitPlanActivityFile) {
      window.open(
        `${this.$store.state.baseURL}/actividad/file/${file.id}`,
        "_blank"
      );
    },
    addActivity() {
      this.selectedActivity = null; // Reinicio actividad seleccionada si es nueva
      this.dialog = true;
    },
    editActivity(activity: Object) {
      this.selectedActivity = activity;
      this.dialog = true;
    },
    goDelActivity(activity: object) {
      this.dialogDeleteActivity = true;
      this.selectedActivity = activity;
    },
    async delActivity() {
      this.loading = true;
      let r = null;
      const activityId = this.selectedActivity.id;
      try {
        r = await this.$store.dispatch(
          "delUnitPlanActivity",
          activityId
        );
        if (r.data && r.data.status && r.data.status.code === 1) {
          this.unit.activity_count--;
          UnitPlan.update({ data: this.unit });
        }
      } catch (e) {
        //console.log(e);
      }

      if (r) {
        UnitPlanActivityDua.delete(
          (detail) => detail.activity_id === activityId
        );
        UnitPlanActivityFile.delete(
          (detail) => detail.activity_id === activityId
        );
        UnitPlanActivityIe.delete(
          (detail) => detail.activity_id === activityId
        );
        UnitPlanActivity.delete(activityId);
      }
      this.refreshActivities();
      this.dialogDeleteActivity = false;
      this.loading = false;
    },
    style(itemIndex: number) {
      const colors = [
        "--v-roma_rcolor-base",
        "--v-primary-base",
        "--v-secondary-base",
        "--v-roma_acolor-base",
      ];
      let color = colors[itemIndex];
      color = `var(${colors[itemIndex % colors.length]})`;

      return color;
    },
  },
  components: {
    RomaConfirmDialog,
    RomaActivityModalForm,
    RomaNotification,
    RomaActivity,
    TiptapVuetify,
    draggable,
    DownloadIcon
  },
});
